<template>
  <div class="container">
    <header>
      <div class="logo">Qard.</div>
    </header>

    <main>
      <section class="hero">
        <h1>Welcome to Qard</h1>
        <p>Your Digital Business card, simplified</p>

        <div class="btn-group">
          <router-link to="edit" class="btn secondary-btn"
            >Edit Qard</router-link
          >

          <router-link to="create" class="btn">Create Qard</router-link>
        </div>
      </section>

      <!-- <section class="about">
        <h2>About Qard</h2>
        <p>
          Qard is your go-to platform for creating elegant and shareable digital
          business cards. With just a few clicks, you can design a personalized
          card, generate a QR code, and share it effortlessly with anyone.
          Simplify your networking with Qard.
        </p>
        <p>
          Whether you're a professional, a freelancer, or simply looking for a
          modern way to connect, Qard helps you make a lasting impression. No
          paper, no hassle—just your details, beautifully displayed.
        </p>
      </section> -->
    </main>
  </div>
</template>

<style scoped>
.container {
  max-width: 75rem;
  margin: 0 auto;
  padding: 20px;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

header .logo {
  font-family: "DM Sans", serif;
  font-weight: 900;
  font-size: 28px;
}

.logo::first-letter {
  font-size: 38px;
}

.hero {
  text-align: center;
  padding: 100px 0;
  background-color: #f0f0f0;
  border-radius: 10px;
  margin-bottom: 40px;

  display: flex;
  flex-direction: column;
  align-items: center;
}

.hero h1 {
  font-size: 3.5rem;
  margin-bottom: 20px;
}

.hero p {
  font-size: 1.5rem;
  margin-bottom: 30px;
}
</style>
